// Explicit list of all topics (works in Vite AND Create-React-App/webpack).
// To add a topic: create topics/<tier>/NN-slug.js and add one line here.
import t0 from './amateur/01-support-and-resistance.js';
import t1 from './amateur/02-breakout.js';
import t2 from './amateur/03-market-structure.js';
import t3 from './amateur/04-chart-pattern.js';
import t4 from './amateur/05-pinbar.js';
import t5 from './amateur/06-engulfing.js';
import t6 from './amateur/07-supply-and-demand.js';
import t7 from './amateur/08-doji.js';
import t8 from './amateur/09-morning-evening-star.js';
import t9 from './amateur/10-fibonacci-retracement.js';
import t10 from './amateur/11-fair-value-gap.js';
import t11 from './amateur/12-order-block.js';
import t12 from './newbie/01-introduction-to-forex.js';
import t13 from './newbie/02-introduction-to-metatrader.js';
import t14 from './newbie/03-risk-management-basics.js';
import t15 from './newbie/04-trend.js';
import t16 from './veteran/01-risk-management.js';
import t17 from './veteran/02-divergence.js';
import t18 from './veteran/03-smart-money-concepts.js';
export default [
  ['amateur', '01-support-and-resistance', t0],
  ['amateur', '02-breakout', t1],
  ['amateur', '03-market-structure', t2],
  ['amateur', '04-chart-pattern', t3],
  ['amateur', '05-pinbar', t4],
  ['amateur', '06-engulfing', t5],
  ['amateur', '07-supply-and-demand', t6],
  ['amateur', '08-doji', t7],
  ['amateur', '09-morning-evening-star', t8],
  ['amateur', '10-fibonacci-retracement', t9],
  ['amateur', '11-fair-value-gap', t10],
  ['amateur', '12-order-block', t11],
  ['newbie', '01-introduction-to-forex', t12],
  ['newbie', '02-introduction-to-metatrader', t13],
  ['newbie', '03-risk-management-basics', t14],
  ['newbie', '04-trend', t15],
  ['veteran', '01-risk-management', t16],
  ['veteran', '02-divergence', t17],
  ['veteran', '03-smart-money-concepts', t18],
];
